import { DocumentTemplate } from "@rumble-it/common-lib/types/models/DocumentTemplate.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input, Select } from "@rumbledirect/ui";
import { Col, Form, Row } from "antd";
import { DocumentTemplatePreviewIframe } from "./DocumentTemplatePreviewIframe";

interface DocumentTemplateFormCardProps {
  mutation: UseMutationResult<null, Error, DocumentTemplate, unknown>;
  loading?: boolean;
  initialValues?: Partial<DocumentTemplate>;
  title?: string;
  buttonText?: string;
}

export const DocumentTemplateFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "Document template aanmaken",
  buttonText = "Aanmaken",
}: DocumentTemplateFormCardProps) => {
  const [form] = Form.useForm();
  const html = (Form.useWatch("html", form) as string | undefined) ?? "";

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Card loading={loading} title={title}>
          <Form
            form={form}
            onFinish={mutation.mutate}
            layout="vertical"
            initialValues={initialValues}
          >
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="Titel"
              name="title"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="Type"
              name="type"
            >
              <Input />
            </Form.Item>
            <Form.Item label="Taal" name="language">
              <Select options={[{ label: "Nederlands", value: "nl" }]} />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="Html"
              name="html"
            >
              <Input.TextArea rows={10} />
            </Form.Item>
            <Form.Item label={null}>
              <Button
                loading={mutation.isPending}
                type="primary"
                htmlType="submit"
              >
                {buttonText}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      <Col span={12}>
        <DocumentTemplatePreviewIframe html={html} title="Live Preview" />
      </Col>
    </Row>
  );
};
